<a (click)="onClose.next()" class="dialog-close">
  <mat-icon>close</mat-icon>
</a>
<tyt-social-buttons [url]="url"></tyt-social-buttons>
